import React from 'react';
import { useTranslation } from 'react-i18next';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <div className={`privacy-policy ${isRTL ? 'rtl' : 'ltr'}`}>
      <div className="container">
        <div className="policy-header">
          <h1>{t('privacy.title')}</h1>
          <p className="last-updated">{t('privacy.lastUpdated')}: {t('privacy.date')}</p>
        </div>

        <div className="policy-content">
          <section className="policy-section">
            <h2>{t('privacy.section1.title')}</h2>
            <p>{t('privacy.section1.content')}</p>
          </section>

          <section className="policy-section">
            <h2>{t('privacy.section2.title')}</h2>
            <p>{t('privacy.section2.content')}</p>
            <ul>
              <li>{t('privacy.section2.item1')}</li>
              <li>{t('privacy.section2.item2')}</li>
              <li>{t('privacy.section2.item3')}</li>
              <li>{t('privacy.section2.item4')}</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>{t('privacy.section3.title')}</h2>
            <p>{t('privacy.section3.content')}</p>
            <ul>
              <li>{t('privacy.section3.item1')}</li>
              <li>{t('privacy.section3.item2')}</li>
              <li>{t('privacy.section3.item3')}</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>{t('privacy.section4.title')}</h2>
            <p>{t('privacy.section4.content')}</p>
          </section>

          <section className="policy-section">
            <h2>{t('privacy.section5.title')}</h2>
            <p>{t('privacy.section5.content')}</p>
          </section>

          <section className="policy-section">
            <h2>{t('privacy.section6.title')}</h2>
            <p>{t('privacy.section6.content')}</p>
          </section>

          <section className="policy-section">
            <h2>{t('privacy.section7.title')}</h2>
            <p>{t('privacy.section7.content')}</p>
            <div className="contact-info">
              <p>
                {t('privacy.contact.email')}: <a href="mailto:privacy@baleeg-om.com">privacy@baleeg-om.com</a>
              </p>
              <p>
                {t('privacy.contact.phone')}: <a href="tel:+96896758894">+968-96758894</a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;